import React from "react";
import usePublicMode from "../../hooks/usePublicMode";

const AssetImg = (props) => {
  const { isPublicPluginsMode } = usePublicMode();
  let { src, ...otherProps } = props;

  if (isPublicPluginsMode) {
    src = `/plugins/assets/${src}`;
  } else {
    src = `/assets/${src}`;
  }

  // eslint-disable-next-line jsx-a11y/alt-text
  return <img src={src} {...otherProps} />;
};

export default AssetImg;
